<template>
  <el-dialog v-if="event" title="Edit an event" :visible.sync="open" :before-close="hide" :append-to-body="true">
    <el-form @keyup.enter.native="save(event)">
      <el-form-item label="Alias" :label-width="formLabelWidth">
        <el-input v-model="event.alias" type="text" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="Score" :label-width="formLabelWidth">
        <el-input-number v-model="event.score" auto-complete="off"></el-input-number>
      </el-form-item>
      <el-form-item label="Activity Wording" :label-width="formLabelWidth">
        <el-input v-model="event.name[lang]" type="text" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="Activity visibility" :label-width="formLabelWidth">
        <el-select v-model="event.visibility" placeholder="Select">
          <el-option v-for="option in visibility.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Frequency limitation" :label-width="formLabelWidth">
        <el-select v-model="event.frequencylimitation" placeholder="Select">
          <el-option v-for="option in frequencylimitation.options" :key="option.value" :label="option.label" :value="option.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="event.frequencylimitation !== 'none'" label="Frequency limitation value" :label-width="formLabelWidth">
        <el-input-number v-model="event.frequencylimitationvalue" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="Type Trigger a visit" :label-width="formLabelWidth">
        <el-radio-group v-model="eventFormTriggerType">
          <el-radio label="1" border="border" @change="setUpReset">None</el-radio>
          <el-radio label="2" border="border" @change="setUpPageViewTrigger">Visit</el-radio>
          <el-radio label="3" border="border" @change="setUpNavigationTrigger">Duration</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="modalType == 'visit'" label="URL" :label-width="formLabelWidth">
        <el-input v-model="event.url" type="text" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item v-if="modalType == 'visit'" label="Total view" :label-width="formLabelWidth">
        <el-input v-model="event.html" type="text" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item v-if="modalType == 'navigation'" label="Visit duration" :label-width="formLabelWidth">
        <el-input v-model="event.html" type="text" auto-complete="off"></el-input>
      </el-form-item>
    </el-form><span class="dialog-footer" slot="footer">
      <el-button v-on:click="hide">{{ 'Cancel' }}</el-button>
      <el-button type="primary" @click="save(event)">{{ 'Save' }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'event-form',

  props: {
    id: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      open: true,
      event: null,

      isEventsLoaded: false,
      isEventFormVisible: false,

      // Dialog create/edit event
      eventFormTriggerType: '1',
      isEventFormEnableTriggerVisit: false,
      isEventFormEnableTriggerDuration: false,

      modalType: 'special',
      formLabelWidth: '150px',
      frequencylimitation: {
        options: [
          {
            text: 'Nothing',
            value: 'none'
          },
          {
            text: 'One times per hour',
            value: 'hour'
          },
          {
            text: 'One times per day',
            value: 'day'
          },
          {
            text: 'One times per week',
            value: 'week'
          },
          {
            text: 'One times per month',
            value: 'month'
          }
        ]
      },
      visibility: {
        options: [
          {
            label: 'action is private',
            value: 'private'
          },
          {
            label: 'action is hidden',
            value: 'hidden'
          },
          {
            label: 'action is public',
            value: 'public'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('events', {
      getById: 'getById'
    }),

    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    isPageViewTrigger () {
      if (
        this.event.type === 'navigation' &&
                (
                  this.event.js === 'read' ||
                    this.event.js === 'visit'
                )
      ) {
        return true
      }

      return false
    },
    isNavigationTrigger () {
      if (
        this.event.type === 'navigation' &&
                this.event.js === 'navigate'
      ) {
        return true
      }

      return false
    },
    isSpecialTrigger () {
      return true
    }
  },
  methods: {
    ...mapActions('events', [
      'addEvent',
      'updateEvent'
    ]),

    show (event) {
      if (event && event.id) {
        this.event = this._.cloneDeep(this.event, false)
      } else {
        this.event.id = ''
        this.event.alias = ''
        this.event.js = 'api'
        this.event.html = ' '
        this.event.private = '0'
        this.event.score = ''
        this.event.type = 'special'
        this.event.url = '.*'
        this.event.visibility = 'public'
        this.event.name[this.lang] = ''
        this.event.frequencylimitation = 'none'
      }
      this.isEventFormVisible = true
    },
    hide () {
      this.open = false
      if (this.event) {
        return this.$emit('close', this.event)
      }
      return this.$emit('close')
    },
    save (event) {
      if (event.id) {
        this.updateEvent({ event: event, sitekey: this.$route.params.site })
          .then(() => {
            this.$notify({
              title: this.$root.$t('Success'),
              message: this.$root.$t('notifications.event.edited'),
              type: 'success'
            })
            this.event = event
            this.hide()
          })
          .catch((response) => {
            this.$notify.error({
              title: this.$root.$t('api.' + response.data.code + '.title'),
              message: this.$root.$t('api.' + response.data.code + '.message')
            })
            this.hide()
          })
      } else {
        this.addEvent({ event: event, sitekey: this.$route.params.site })
          .then((event) => {
            this.$notify({
              title: this.$root.$t('Success'),
              message: this.$root.$t('notifications.event.added'),
              type: 'success'
            })
            this.event = event
            this.hide()
          })
          .catch((response) => {
            this.$notify.error({
              title: this.$root.$t('api.' + response.data.code + '.title'),
              message: this.$root.$t('api.' + response.data.code + '.message')
            })
            this.hide()
          })
      }
    },

    setUpPageViewTrigger (enable) {
      if (enable) {
        this.$set(this.event, 'type', 'navigation')
        this.$set(this.event, 'js', 'visit')
        this.modalType = 'visit'
      } else {
        this.setUpReset()
      }
    },
    setUpNavigationTrigger (enable) {
      if (enable) {
        this.$set(this.event, 'type', 'navigation')
        this.$set(this.event, 'js', 'navigate')
        this.modalType = 'navigation'
      } else {
        this.setUpReset()
      }
    },
    setUpReset () {
      this.$set(this.event, 'type', 'special')
      this.$set(this.event, 'js', 'api')
      this.modalType = 'api'
    }
  },
  mounted () {
    if (this.id) {
      this.event = this._.cloneDeep(this.getById(this.id), false)
      if (!this.event.name[this.lang]) {
        this.event.name = {}
      }
    } else {
      this.event = {
        alias: null,
        js: 'api',
        html: ' ',
        private: 0,
        score: null,
        type: 'special',
        url: '.*',
        name: {},
        visibility: 'public',
        frequencylimitation: 'none'
      }
      this.event[this.lang] = ''
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/events/event-form.vue